import { ContentTranslation } from '../../models/content-translation.model';
import { EMPTY_TEXT, FIRST_INDEX, HTTP_LINK_PREFIX, INDEX_NOT_FOUND } from './my-working-report.constants';
import { KarmaContent } from './karma-content.model';

export function mapKarmaLinks(list: KarmaContent[]): KarmaContent[] {
  return list.map((item: KarmaContent) => mapKarmaLink(item));
}

function mapKarmaLink(item: KarmaContent): KarmaContent {
  const description = item.description || EMPTY_TEXT;
  const linkIndex = description.indexOf(HTTP_LINK_PREFIX);
  if (linkIndex === INDEX_NOT_FOUND) {
    return item;
  }
  return Object.assign({}, item, {
    description: description.substring(FIRST_INDEX, linkIndex),
    descriptionTranslation: removeTranslationLink(item.descriptionTranslation),
    link: description.substring(linkIndex)
  });
}

function removeTranslationLink(
  translation: ContentTranslation | null | undefined
): ContentTranslation | null | undefined {
  if (!translation) {
    return translation;
  }
  return {
    ru: removeLinkValue(translation.ru),
    en: removeLinkValue(translation.en),
    zh: removeLinkValue(translation.zh)
  };
}

function removeLinkValue(value: string | null | undefined): string | null | undefined {
  if (!value) {
    return value;
  }
  const linkIndex = value.indexOf(HTTP_LINK_PREFIX);
  return linkIndex === INDEX_NOT_FOUND ? value : value.substring(FIRST_INDEX, linkIndex);
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/my-working-report/my-working-report-karma.mapper.ts